module.exports = __webpack_public_path__ + "img/rank_no_data.a65e39d5.png";